import {
  useWSModalCustom,
  WSCard,
  WSElement,
  WSInfoBox,
  WSList,
  WSModal,
  WSModalCustomProps,
  WSText
} from "@wingspanhq/fe-component-library";
import { useUserId } from "../../../../query/hooks/helpers";
import { useQueryCustomerEntity } from "../../../../query/onboarding/queries/useQueryCustomerEntity";
import { useQueryMemberProfile } from "../../../../query/users/queries";
import { selectorUseInternationalInstantPayouts } from "../../../../shared/selectors/selectorUseInternationalInstantPayouts";
import { useInstantPayoutFee } from "../../hooks/useInstantPayoutFee";
import { InstantPayoutPayoutCA } from "../InstantPayoutPayoutCA";
import { InstantPayoutPayoutUS } from "../InstantPayoutPayoutUS";

type Props = WSModalCustomProps<void>;

export const ModalInfo: React.FC<Props> = props => {
  const userId = useUserId();
  const ipFee = useInstantPayoutFee();
  const queryMember = useQueryMemberProfile(userId);
  const queryCustomerEntity = useQueryCustomerEntity();

  const isInternational =
    queryMember.data &&
    selectorUseInternationalInstantPayouts(
      queryMember.data,
      queryCustomerEntity.data
    );

  return (
    <WSModal
      title={`Instant payout methods (${ipFee}% fee)`}
      actions={{
        alignment: "fill",
        buttons: [
          {
            kind: "Tertiary",
            onClick: () => {
              props.onClose();
            },
            label: "Done"
          }
        ]
      }}
      {...props}
    >
      <WSList gap="2XL">
        <WSInfoBox>
          The following account(s) may have instant payouts available. Please
          check your financial institution's online banking portal, as some
          banks may require you to opt in or enable the service manually.
        </WSInfoBox>

        {isInternational ? (
          <WSElement>
            <WSText.Caption weight="medium" mb="M">
              Canada
            </WSText.Caption>
            <WSCard>
              <InstantPayoutPayoutCA />
            </WSCard>
          </WSElement>
        ) : (
          <WSElement>
            <WSText.Caption weight="medium" mb="M">
              United States
            </WSText.Caption>
            <WSCard>
              <InstantPayoutPayoutUS />
            </WSCard>
          </WSElement>
        )}
      </WSList>
    </WSModal>
  );
};

export const useModalInfo = () => useWSModalCustom(ModalInfo);
